import { useEffect, useState, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { useIsDesktop } from "../../hooks/useIsDesktop";

const DESKTOP_ACTIONS_ID = "owner-desktop-page-actions";
const PHONE_ACTIONS_ID = "owner-phone-page-actions";

/** Keeps page-owned state local while placing the page's keys in the shell. Desktop: the head of the sheet. Phone (canvas
 * v2-om-*): the main key (any key that is not `o-btn--line`) is fixed at the bottom of the screen, and the line keys are
 * the items of the ⋯ menu in the head. Both are styled in portal.css (`.o-pacts`). */
export function PageHeaderActions({ children }: { children: ReactNode }) {
  const isDesktop = useIsDesktop();
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTarget(document.getElementById(isDesktop ? DESKTOP_ACTIONS_ID : PHONE_ACTIONS_ID));
  }, [isDesktop]);

  if (target) return createPortal(children, target);
  return isDesktop ? null : <div className="owner-page-actions--mobile">{children}</div>;
}

const PAGE_BANNER_ID = "owner-page-banner";

/** A page's own banner, shown above the page title (canvas v2-o-billing-*). */
export function PageBanner({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  useEffect(() => setTarget(document.getElementById(PAGE_BANNER_ID)), []);
  return target ? createPortal(children, target) : null;
}

export { DESKTOP_ACTIONS_ID, PHONE_ACTIONS_ID, PAGE_BANNER_ID };
